export const MODAL_DELETE_ID = 'deleteModal'

export const CV_VALUE_TYPE_PROD = 'typr'
export const CV_VALUE_SUBJECT = 'subj'
export const CV_VALUE_REGION = 'regn'
export const CV_VALUE_EDUCATION = 'edct'
export const CV_VALUE_COURSE_LEVEL = 'coul'
export const CV_VALUE_LANGUAGE = 'lang'
export const CV_VALUE_COUNTRY = 'coun'
export const CV_VALUE_PRODUCTION_MODE = 'eppm'
export const CV_VALUE_EDITORIAL_PROJECT = 'edpr'
export const CV_VALUE_EDITORIAL_PROJECT_STATUS = 'epst'
export const CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT = 'epbu'
export const CV_VALUE_TYPE_ELEMENT = 'tyel'
export const CV_VALUE_ELEMENT_RELATION_TYPE = 'elrt'
export const CV_VALUE_TYPE_ELEMENT_EC = 'tyec'
export const CV_VALUE_VIEWER_TYPE = 'vity'
export const CV_VALUE_QUARTER = 'quar'
export const CV_VALUE_CONCEPT_ICONS = 'coic'
export const CV_VALUE_SHORT_CODE_INDEF = 'indef'
export const CV_VALUE_FILE_NAME_RULE = 'fnru'
export const CV_VALUE_ELEMENT_METADATA_FIELDS = 'emfi'
export const CV_VALUE_ELEMENT_TYPE_CATEGORIES = 'etca'
export const CV_VALUE_SMA_TYPES = 'smat'
export const CV_VALUE_PRODUCT_STATUS_TYPE = 'prst'
export const CV_VALUE_PRODUCT_WORK_TYPE = 'prwt'
export const CV_VALUE_MATERIAL_TYPE = 'tmat'
export const CV_VALUE_PRODUCT_COLLECTION = 'prco'
export const CV_VALUE_PRODUCT_SERIES = 'prse'

export const CV_VALUE_FULL_CPG = 'eppm-fcpg'
export const CV_VALUE_WW_GLOBAL_ARCHIVE = 'eppm-wwga'
export const CV_VALUE_ONLY_WW = 'eppm-onww'
export const CV_VALUE_ONLY_SMA = 'eppm-onsma'
export const CV_VALUE_ONLY_ARCHIVE = 'eppm-onar'

export const CV_VALUE_SMA_TYPE_N3 = 'smat-n3'
export const CV_VALUE_SMA_TYPE_N4 = 'smat-n4'

export const CV_VALUE_COUNTRY_ES = 'coun-es'
export const CV_VALUE_COUNTRY_CL = 'coun-cl'
export const CV_VALUE_COUNTRY_BR = 'coun-br'
export const CV_VALUE_COUNTRY_MX = 'coun-mx'
export const CV_VALUE_COUNTRY_PE = 'coun-pe'
export const CV_VALUE_COUNTRY_PR = 'coun-pr'
export const CV_VALUE_COUNTRY_DO = 'coun-do'
export const CV_VALUE_COUNTRY_CO = 'coun-co'
export const CV_VALUE_COUNTRY_EC = 'coun-ec'
export const CV_VALUE_COUNTRY_AR = 'coun-ar'

export const CV_VALUE_CATEGORY_BLOCK = 'etca-bloq'
export const CV_VALUE_CATEGORY_ANEXO = 'etca-anex'
export const CV_VALUE_CATEGORY_SECUENCIA_DIGITAL = 'etca-secd'
export const CV_VALUE_CATEGORY_NIVELADOR = 'etca-nivl'
export const CV_VALUE_CATEGORY_UNIDAD = 'etca-unid'
export const CV_VALUE_CATEGORY_RECURSOS_UNIDAD = 'etca-reun'

export const CV_VALUE_EDITORIAL_PROJECT_STATUS_ACTIVE = 'epst-acti'
export const CV_VALUE_EDITORIAL_PROJECT_STATUS_NOT_ACTIVE = 'epst-noac'
export const CV_VALUE_EDITORIAL_PROJECT_STATUS_PREP_PRODUCCION = 'epst-prep'
export const CV_VALUE_EDITORIAL_PROJECT_STATUS_REV_CORRECCION = 'epst-rvcr'

export const EDITORIAL_PROJECT_STATUS_COLOR_ACTIVE = 'success'
export const EDITORIAL_PROJECT_STATUS_COLOR_NOT_ACTIVE = 'secondary'
export const EDITORIAL_PROJECT_STATUS_COLOR_PREP_PRODUCCION = 'warning'
export const EDITORIAL_PROJECT_STATUS_COLOR_REV_CORRECCION = 'info'

export const TYPR_DIGITAL_COURSE = 'typr-cdig'
export const TYPR_WEBPACK_COURSE = 'typr-webpack'
export const TYPR_BOOK = 'typr-libro'
export const TYPR_PACK = 'typr-pack'
export const TYPR_DIGITAL_RESOURCES = 'typr-rdd'

export const TYEL_BOOK = 'libro'
export const TYEL_NOTEBOOK = 'cuade'
export const TYEL_INDEF = 'indef'
export const TYEL_BLOCK = 'bl'
export const TYEL_BLOCK_UNIT = 'un'
export const TYEL_UNIT = 'ud'
export const TYEL_CHAPTER = 'CP'
export const TYEL_SA = 'sa'
export const TYEL_SECTION = 'se'
export const TYEL_PART = 'ap'
export const TYEL_RESOURCE = 'recurso'
export const TYEL_ANNEX = 'anexo'
export const TYEL_FICHA = 'ficha'
export const TYEL_LIBROTRIM1 = 'librotrim1'
export const TYEL_LIBROTRIM2 = 'librotrim2'
export const TYEL_LIBROTRIM3 = 'librotrim3'
export const TYEL_GUIATRIM1 = 'guiatrim1'
export const TYEL_GUIDE = 'guia'
export const TYEL_ADENDA = 'adenda'
export const TYEL_PET = 'mascota'
export const TYEL_CUTS = 'recort'
export const TYEL_ADHESIVE = 'adhesivos'
export const TYEL_INTERCOMP = 'intercomp'
export const TYEL_INTERMED = 'intermed'

export const TYEL_DIGITAL_BOOK = 'librodig'
export const TYEL_DIG_BLOCK = 'bldig'
export const TYEL_DIG_BLOCK_ALT = 'bldigalt'
export const TYEL_DIG_SA = 'sadig'
export const TYEL_DIG_UNIT = 'uddig'
export const TYEL_DIG_UNIT_LDX = 'saldx'
export const TYEL_DIG_UNIT_VIEW = 'savisor'
export const TYEL_DIG_SECTION = 'sedig'
export const TYEL_DIG_PART = 'apdig'
export const TYEL_DIG_SA_REC = 'sarec'

export const FILTER_TEAM_MEMBER_TYPE_MANAGER = 'manager'

export const PRODUCT_ELEMENTS_EXCEL_EXPORT_COMPLETE = 'productElementsExcelExportComplete'
export const PRODUCT_ELEMENTS_EXCEL_EXPORT_FOR_UPDATE = 'productElementsExcelExportForUpdate'

export const ELEMENT_STATUS_FILE_FORMAT_INDESIGN = 'indesign'
export const ELEMENT_STATUS_FILE_FORMAT_WORD = 'word'

export const TRACING_SITUATION_COMPLETED = 'success'
export const TRACING_SITUATION_ADVANCED = 'primary'
export const TRACING_SITUATION_GOOD = 'info'
export const TRACING_SITUATION_WARNING = 'warning'
export const TRACING_SITUATION_DANGER = 'danger'

export const TRACING_PERCENTAGE_SITUATION_COMPLETED = 100
export const TRACING_PERCENTAGE_SITUATION_GOOD = 85

export const DEFAULT_ASSET_TENANT = 'es'

export const APP_CCP = 'ccp'

export const ROLE_ACCESS = 'ACCESS'
export const ROLE_READ = 'READ'
export const ROLE_EDITOR = 'EDITOR'
export const ROLE_SPECIAL = 'SPECIAL'
export const ROLE_ADMIN = 'ADMIN'

export const DEFAULT_ICON_PRODUCT = 'ti-default-product'
export const DEFAULT_ICON_ELEMENT_TYPE = 'ti-default-element'

export const SECURITY_ACTION_REMOVE = 'REMOVE'
export const SECURITY_ACTION_DISABLE = 'DISABLE'

export const ACCOUNT_ACTIONS_BUTTON_NEW_PRODUCT = 'BUTTON_NEW_PRODUCT'
export const ACCOUNT_ACTIONS_BUTTON_NEW_EDITORIAL_PROJECT = 'BUTTON_NEW_EDITORIAL_PROJECT'
export const ACCOUNT_ACTIONS_BUTTON_EDIT_EDITORIAL_PROJECT = 'BUTTON_EDIT_EDITORIAL_PROJECT'
export const ACCOUNT_ACTIONS_BUTTON_EDIT_PRODUCT_STATUS_TYPE = 'BUTTON_EDIT_PRODUCT_STATUS_TYPE'
export const ACCOUNT_ACTIONS_BUTTON_DELETE_PRODUCT = 'BUTTON_DELETE_PRODUCT'
export const ACCOUNT_ACTIONS_BUTTON_COPY_PROCESSED_RELATED_PARTS = 'BUTTON_COPY_PROCESSED_RELATED_PARTS'

// Product structure error types (catalogued, extensible for future error types)
export const STRUCTURE_ERROR_TYPE_DUPLICATED_CODE = 'DUPLICATED_CODE'

// Account profile types
export const ACCOUNT_PROFILE_ADMIN = 'ADMIN'
export const ACCOUNT_PROFILE_MANAGER = 'MANAGER'
export const ACCOUNT_PROFILE_USER = 'USER'

// Dates as shown in the app and in the generated documents
export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm'
